







import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ComponentLogo extends Vue {
  @Prop({ default: '/img/logos/logo-finx.png' }) img: string
  @Prop({ default: 'Fin-X' }) alt: string
}
